// extracted by mini-css-extract-plugin
export default {"buttonClose":"ModalDeleteTuition_buttonClose__qoWvi","iconCloseModal":"ModalDeleteTuition_iconCloseModal__c4FlE"};